<template>
  <modal
    :title="title"
    :fullscreen="false"
    :resize-modal="true"
    @close="close"
  >
    <div :class="$style.content">
      <iframe
        ref="iframe"
        :class="$style.iframe"
        :srcdoc="currentItem.textRaw || currentItem.text"
        sandbox
      />
    </div>
    <template v-slot:footer>
      <footer :class="$style.footer">
        <div :class="$style.group">
          <div :class="$style.item">
            <button-blue-icon
              :disabled="isFirst"
              @click="prev"
            >
              <inline-svg
                :src="require('@/assets/images/icons/computer/screenshots/modal/prev.svg')"
                :alt="$t('pages.modal.back')"
                :title="$t('pages.modal.back')"
              />
            </button-blue-icon>
          </div>
        </div>

        <div :class="$style.group">
          <div :class="$style.item">
            <button-blue-icon
              :disabled="isLast"
              @click="next"
            >
              <inline-svg
                :src="require('@/assets/images/icons/computer/screenshots/modal/next.svg')"
                :alt="$t('pages.modal.forward')"
                :title="$t('pages.modal.forward')"
              />
            </button-blue-icon>
          </div>
        </div>
      </footer>
    </template>
  </modal>
</template>

<script>
  import { InlineSvgComponent } from 'vue-inline-svg';
  import Modal from '@/components/common/modal/index.vue';
  import ButtonBlueIcon from '@/components/common/button/button-blue-icon.vue';

  export default {
    components: {
      ButtonBlueIcon,
      inlineSvg: InlineSvgComponent,
      Modal,
    },
    props: {
      data: {
        type: Array,
        required: true,
      },
    },
    data: () => ({
      slideshow: {
        forward: true,
        interval: 1000,
        timeout: null,
      },
    }),
    computed: {
      title() {
        return this.currentItem.subject;
      },
      currentId() {
        return parseInt(this.$route.params.record, 10);
      },
      currentIndex() {
        return this.data.findIndex((i) => i.id === this.currentId);
      },
      currentItem() {
        return this.data.find((i) => i.id === this.currentId);
      },
      isFirst() {
        return this.currentIndex <= 0;
      },
      isLast() {
        return this.currentIndex >= this.data.length - 1;
      },
    },
    mounted() {
      window.addEventListener('keydown', this.keydownListener);
    },
    beforeDestroy() {
      window.removeEventListener('keydown', this.keydownListener);
    },
    methods: {
      /**
       * @param {KeyboardEvent} e
       */
      keydownListener(e) {
        if (e.key === 'ArrowLeft') {
          this.prev();
          e.preventDefault();
          e.stopPropagation();
        } else if (e.key === 'ArrowRight') {
          this.next();
          e.preventDefault();
          e.stopPropagation();
        } else if (e.key === 'Escape') {
          // FIXME: Возможно, не самое лучшая реализация
          this.close();
          e.preventDefault();
          e.stopPropagation();
        }
      },
      close() {
        this.$emit('close');
      },
      switchData(item) {
        if (item) {
          this.$router.replace({
            params: {
              record: item.id,
            },
            query: this.$route.query,
          });
        }
      },
      prev() {
        this.switchData(this.data[this.currentIndex - 1]);
      },
      next() {
        this.switchData(this.data[this.currentIndex + 1]);
      },
    },
  };
</script>

<style lang="scss" module>
  .content {
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .footer {
    text-align: center;
    position: relative;
    display: flex;
    justify-content: center;
  }

  .group {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 10px;
  }

  .item {
    flex-shrink: 0;

    &:not(:last-child) {
      margin-right: 6px;
    }
  }

  .iframe {
    width: 100%;
    height: 100%;
  }
</style>
